exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-results{list-style-type:none;display:inline-block;padding-left:0}.autocomplete-result{float:left;clear:left;padding:5px 10px;border:1px solid grey;border-top:none;background-color:#fff;width:100%}.autocomplete-result:hover{background-color:#e9f3fc}", ""]);

// exports
